export default function About() {
  const aboutFeatures = [
    {
      title: "Enhance Your Potential",
      description:
        "The process of setting goals, acquiring new skills, expanding your knowledge, and building positive habits to improve your overall performance in the logistics industry.",
      image: "../images/exchange-ideas.png",
    },
    {
      title: "Skilling and Reskilling",
      description:
        "Update and enhance your current abilities to stay proficient and competitive. Learn new technologies and tools relevant to logistics operations and leadership.",
      image: "/images/skill.png",
    },
    {
      title: "Career Growth",
      description:
        "Gain the skills, experience, and confidence needed to move into senior roles, earn better compensation, and achieve professional satisfaction in your logistics career.",
      image: "/images/career-growth.png",
    },
    {
      title: "Stay Relevant",
      description:
        "Stay up to date in a competitive world and grab more opportunities. Our courses are regularly upgraded for an impactful, modern learning experience.",
      image: "/images/gaps.png",
    },
  ];

  return (
    <section className="max-w-screen-xl mx-auto py-20 px-7 md:px-16">
      <div className="text-center mb-14">
        <h1 className="text-3xl py-5 md:text-4xl md:leading-tight font-bold text-gray-900">
          Why Learn from Our <span className="text-blue-600">E-Learning Programmes</span> in Logistics?
        </h1>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-14">
        {aboutFeatures.map((feature, index) => (
          <div key={index} className="sm:flex gap-6 items-center">
            <img
              src={feature.image}
              alt={feature.title}
              className="w-24 h-24 object-cover rounded-2xl flex-none"
            />
            <div>
              <span className="mb-2 inline-block text-base font-semibold mt-5 sm:mt-0">
                {feature.title}
              </span>


              <p className="text-sm leading-relaxed font-normal text-gray-700">
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
